import React from "react";
//import Preview from "../views/Preview";
import HomeLight from "../views/all-home-version/HomeLight";
// import HomeDark from "../views/all-home-version/HomeDark";
import EmailLegalNotice from "../components/legal/EmailLegalNotice";
import NotFound from "../views/NotFound";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";
import { LanguageProvider } from "../context/LanguageContext";

const Routes = () => {
  return (
    <Router>
      <LanguageProvider>
        <ScrollTopBehaviour />
        <Switch>
          <Route exact path="/" component={HomeLight} />
          <Route path="/2025-12-07-email-jogi-nyilatkozat" component={EmailLegalNotice} />
          <Route path="/home-light" component={HomeLight} />
          <Route component={NotFound} />
        </Switch>
      </LanguageProvider>
    </Router>
  );
};


export default Routes;
